import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DirectMailComponent } from './direct-mail.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PurchaseEmissionsModule } from '../purchase-emissions/purchase-emissions.module';

@NgModule({
  declarations: [
    DirectMailComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PurchaseEmissionsModule
  ],
  exports: [
    DirectMailComponent
  ]
})
export class DirectMailModule { }
